import { AnalyticsReportType } from '../../../../Generated/Raven-Demeter';

export const reportTypes = [
    AnalyticsReportType.BackendRequests,
    AnalyticsReportType.BackendUserRequests,
    AnalyticsReportType.BackendMostActiveUsers,
    AnalyticsReportType.BackendEndpointsUsage,
    AnalyticsReportType.FrontendPageViews,
    AnalyticsReportType.FrontendUserPageViews,
    AnalyticsReportType.FrontendUserDetails,
    AnalyticsReportType.FrontendClicks,
    AnalyticsReportType.FrontendUserClicks,
    AnalyticsReportType.FrontendClicksCount,
    AnalyticsReportType.FrontendUserClicksCount,
];
export const defaultReportType = reportTypes[0];
export const defaultDateFrom = new Date(new Date().setDate(new Date().getDate() - 1));
export const defaultDateTo = new Date();
export const limits = [100, 200, 500, 1000, 2000, 5000, 10000];
export const defaultLimit = limits[0];
